export var a11yRegionId = 'a11y-region';
export var defaultText = '';
export var defaultTone = 'polite';
export var defaultRole = 'status';
export function retrieveA11yRegion() {
  var liveRegion = document.getElementById(a11yRegionId);
  return liveRegion ? {
    liveRegion: liveRegion,
    message: liveRegion.textContent,
    tone: liveRegion.getAttribute('aria-live'),
    role: liveRegion.getAttribute('role')
  } : {};
}

function createA11yRegion() {
  var a11yRegion = document.createElement('div');
  a11yRegion.setAttribute('id', a11yRegionId);
  a11yRegion.setAttribute('role', defaultRole);
  a11yRegion.setAttribute('aria-live', defaultTone);
  a11yRegion.setAttribute('aria-atomic', 'true');
  Object.assign(a11yRegion.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  return a11yRegion;
}

export function getA11yRegion() {
  /* istanbul ignore next */
  if (typeof document === 'undefined') {
    return null;
  }

  var _retrieveA11yRegion = retrieveA11yRegion(),
      currentA11yRegion = _retrieveA11yRegion.liveRegion;

  if (currentA11yRegion) {
    return currentA11yRegion;
  }

  var a11yRegion = createA11yRegion();
  document.body.appendChild(a11yRegion);
  return a11yRegion;
}
export function getA11yAttributes() {
  return retrieveA11yRegion();
}
var timer;
export function setA11yMessage(messageText, messageTone, messageRole) {
  var clearAfter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;
  var region = getA11yRegion();
  region.setAttribute('aria-live', messageTone || defaultTone);
  region.setAttribute('role', messageRole || defaultRole);
  region.textContent = '';
  region.textContent = messageText || defaultText;
  clearTimeout(timer);
  timer = setTimeout(function () {
    region.textContent = '';
  }, clearAfter);
}
export function resetA11yMessage() {
  var region = getA11yRegion();
  region.setAttribute('aria-live', defaultTone);
  region.setAttribute('role', defaultRole);
  region.textContent = defaultText;
}